import { createContext } from 'react';
import type { ModalSize } from './Modal';

type ModalContextType = {
  size: ModalSize;
};

export const ModalContext = createContext<ModalContextType>({
  size: 'medium',
});
